import React, { useState } from 'react';
import InnerPageLayout from '../components/ui/InnerPageLayout';
import Accordion from '../components/ui/Accordion';
import PageSEO from '../components/legal/PageSEO';
import SummaryCards from '../components/legal/SummaryCards';
import SectionHeading from '../components/legal/SectionHeading';
import ContactCTA from '../components/legal/ContactCTA';
import {
  PRIVACY_SUMMARY_CARDS,
  PRIVACY_SECTIONS,
  PRIVACY_LAST_UPDATED,
} from '../content/privacyContent';

function Privacy() {
  const [openSection, setOpenSection] = useState(0);

  return (
    <InnerPageLayout
      tag="Privacy First • No Data Selling"
      title="Privacy"
      titleAccent="Policy"
      description="Privacy matters here — especially for queer and closeted users. Learn what StrapIn collects, how safety evidence helps investigate scams and serious reports, and how we restrict access and disclosure."
      wide
    >
      <PageSEO
        title="Privacy Policy"
        description="StrapIn Privacy Policy — profile data, chats, Safe Meet, IP and device security records, retention, legal requests, GDPR, DPDP, and deletion rights."
        path="/privacy"
      />

      <p className="-mt-8 mb-12 text-center text-xs text-silver">
        Last updated: {PRIVACY_LAST_UPDATED}
      </p>

      <section className="mb-16">
        <SectionHeading
          tag="Our commitments"
          title="Built Around Trust"
          description="Six things we want you to know before you read the details."
        />
        <SummaryCards items={PRIVACY_SUMMARY_CARDS} columns="sm:grid-cols-2 xl:grid-cols-3" />
      </section>

      <section id="privacy-details" className="mb-16">
        <SectionHeading
          tag="Full policy"
          title="How We Handle Your Data"
          description="What we collect, why we need it, how long we keep it, and who may access it."
        />
        <Accordion items={PRIVACY_SECTIONS} openIndex={openSection} onToggle={setOpenSection} />
      </section>

      <ContactCTA
        icon="🔐"
        title="Your Data, Your Rights"
        description="Request access, correction, or deletion anytime. We will help."
        emails={[
          { label: 'privacy@strapinapp.com', href: 'mailto:privacy@strapinapp.com' },
          { label: 'support@strapinapp.com', href: 'mailto:support@strapinapp.com' },
        ]}
        links={[
          { label: 'Account Deletion', to: '/account-deletion' },
          { label: 'Safety Center', to: '/safety' },
        ]}
      />
    </InnerPageLayout>
  );
}

export default Privacy;
